import { getWhiteLabelBrand } from '../js/whiteLabel';

export default async () => {
  let navRibbonWillTimeout = null;
  let navRibbonSuppressSearch = false;
  await O.hydrateUserSession();
  const brand = getWhiteLabelBrand();
  const brandLogo = brand
    ? `<img class="nav-white-label" src="${brand.logo}" alt="${brand.alt}">`
    : '';

  const getNav = 'navigation/get-navigation-elements';
  const vars = {};
  const {value} = await O.getCookie('ewttgpvwwkf');
  vars.user_uuid = value;

  const res = await O.PREP([await O.mGET(getNav, vars)]);
  const navElements = res[getNav].data;

  let navList = '';

  for (let nav in navElements) {
    const el = navElements[nav];

    const navItem = `
      <a id="${el.html_text}" class="nav-item" onclick="O.PREP('${el.html_text}'), U.navSel(this.id)">${el.short_text}</a>
    `;

    let subList = '';

    for (let sub of el.subMenu) {
      subList += `
        <div class="subItem" onclick="O.PREP('${sub.html_text}'), U.navSel('${el.html_text}')">${sub.short_text}</div>
      `;
    }
    navList += `
      <li>
        ${navItem}
        <div class="subMenu">
          ${subList}
        </div>
      </li>
    `;
  }

  const div = `
        <nav>

        <div onclick="O.PREP('HomePage')">
        <img  src="legatus-logo-nav.png" alt="Legatus Logo">
        </div>
        <div class="nav-menu-cluster">
        <div class="nav-ribbon-filters">
        <button type="button" id="navRibbonFlaggedBtn" class="btn nav-ribbon-filter-btn" aria-label="Flagged applications" title="Flagged applications">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v18M8 3h9l-3 4 3 4H8" />
        </svg>
        </button>
        <button type="button" id="navRibbonRecentBtn" class="btn nav-ribbon-filter-btn nav-ribbon-filter-recent" aria-label="Recent 20 applications" title="Recent 20 applications">20</button>
        </div>
        <div class="nav-ribbon-input-wrap">
        <input type="text" id="navRibbonInput" name="willNumberSearchNav" class="nav-ribbon-input" placeholder="Will number (only)" autocomplete="off" aria-label="Will number (only)">
        <button type="button" class="nav-ribbon-clear" aria-label="Clear text" title="Clear" hidden>&times;</button>
        </div>
          <ul>
            ${navList}
          </ul>
        </div>
        <div class="nav-profile flex items-center">
          ${brandLogo}
          <span>
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19" cy="19" r="19" fill="white"/>
            <path d="M25.6663 26.5V24.8333C25.6663 23.9493 25.3152 23.1014 24.69 22.4763C24.0649 21.8512 23.2171 21.5 22.333 21.5H15.6663C14.7823 21.5 13.9344 21.8512 13.3093 22.4763C12.6842 23.1014 12.333 23.9493 12.333 24.8333V26.5" stroke="#3B71CA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.0003 18.1667C20.8413 18.1667 22.3337 16.6743 22.3337 14.8333C22.3337 12.9924 20.8413 11.5 19.0003 11.5C17.1594 11.5 15.667 12.9924 15.667 14.8333C15.667 16.6743 17.1594 18.1667 19.0003 18.1667Z" stroke="#3B71CA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="subMenu">
            <div class="subItem" onclick="O.PREP('Profile'), U.navSel()">My profile</div>
            <div class="subItem" onclick="O.logout()">Logout</div>
            </div>
          </span>
        </div>

        </nav>
  `;

  const navRoot = U.id('mainNavigation').appendChild(U.createHTMLElementFromString(div));
  const navInput = U.id('navRibbonInput');
  const clearBtn = navRoot.querySelector('.nav-ribbon-clear');
  const flaggedBtn = U.id('navRibbonFlaggedBtn');
  const recentBtn = U.id('navRibbonRecentBtn');

  const runNavListFilter = (mode) => {
    const onManage = window.thsPage && window.thsPage.pageTitle === 'ManageApplications';
    if (onManage && typeof window.thsPage.applyNavListFilter === 'function') {
      window.thsPage.applyNavListFilter(mode);
    } else {
      O.PREP('ManageApplications', { nav_filter: mode });
    }
  };

  if (flaggedBtn) {
    flaggedBtn.addEventListener('click', (e) => {
      e.preventDefault();
      runNavListFilter('flagged');
    });
  }

  if (recentBtn) {
    recentBtn.addEventListener('click', (e) => {
      e.preventDefault();
      runNavListFilter('recent');
    });
  }

  if (navInput) {
    const updateClearBtn = () => {
      if (clearBtn) clearBtn.hidden = !navInput.value.trim();
    };

    const runNavWillSearch = () => {
      if (navRibbonSuppressSearch) {
        navRibbonSuppressSearch = false;
        return;
      }
      clearTimeout(navRibbonWillTimeout);
      navRibbonWillTimeout = setTimeout(() => {
        const v = navInput.value.trim();
        const onManage = window.thsPage && window.thsPage.pageTitle === 'ManageApplications';
        if (onManage) {
          const willEl = U.id('willNumberSearch');
          if (willEl) willEl.value = v;
          if (typeof window.thsPage.debouncedGetAppList === 'function') {
            window.thsPage.debouncedGetAppList();
          }
        } else {
          O.PREP('ManageApplications', { will_filter: v });
        }
      }, 1000);
    };

    const onNavRibbonType = () => {
      updateClearBtn();
      runNavWillSearch();
    };

    navInput.addEventListener('keyup', onNavRibbonType);
    navInput.addEventListener('input', onNavRibbonType);
    updateClearBtn();
    window.updateNavRibbonClearBtn = updateClearBtn;

    if (clearBtn) {
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(navRibbonWillTimeout);
        navRibbonSuppressSearch = true;
        navInput.value = '';
        updateClearBtn();
        navInput.focus();
      });
    }
  }

  return navRoot;
};
